import { PermissionsCategory } from "src/app/auth/permissions";

@PermissionsCategory("MediationPermissions")
export class MediationPermissions {
    static readonly None = 0;
    static readonly ViewSummary = 1;
    static readonly View = 2;
    static readonly Edit = 4;
    static readonly Delete = 8;
    static readonly SeeAll = 16;
    static readonly Export = 32;
}